// libs
import React, { memo } from "react";
import styled from "@emotion/styled";

// global components
import SubNav from "shared/components/SubNav";
import SearchInput from "./components/SearchInput";

const SearchContainer = styled.div`
    & > .sh-ico {
        margin-right: 6px;
        font-size: 0.92rem;
        color: #666;
        position: relative;
        top: 1px;
    }
`;

const SEARCH_TEXT = "Search";

function Search() {
    return (
        <SubNav subMenu={<SearchInput />}>
            <SearchContainer>
                <i className="icon-magnify sh-ico" />
                {SEARCH_TEXT}
            </SearchContainer>
        </SubNav>
    );
}

export default memo(Search);
